import React, { useState, useEffect } from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "500px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

const formFieldStyle = {
  marginBottom: "16px",
};

const buttonGroupStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "24px",
};

const EditProductModal = ({ open, onClose, product, onSave }) => {
  const [formValues, setFormValues] = useState({
    name: "",
    price: "",
    description: "",
  });

  useEffect(() => {
    if (product) {
      setFormValues({
        name: product.title.translations.en_us,
        price: product.price_info.price,
        description: product.description.translations.en_us,
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = () => {
    const updatedProduct = {
      ...product,
      title: { translations: { en_us: formValues.name } },
      price_info: { price: Number(formValues.price) },
      description: { translations: { en_us: formValues.description } },
    };
    onSave(updatedProduct);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" sx={{ mb: 3, textAlign: "center" }}>
          Edit Product Details
        </Typography>
        <form>
          <TextField
            label="Product Name"
            name="name"
            fullWidth
            value={formValues.name}
            onChange={handleChange}
            sx={formFieldStyle}
            variant="outlined"
            required
          />
          <TextField
            label="Price"
            name="price"
            type="number"
            fullWidth
            value={formValues.price}
            onChange={handleChange}
            sx={formFieldStyle}
            variant="outlined"
            required
          />
          <TextField
            label="Description"
            name="description"
            multiline
            rows={4}
            fullWidth
            value={formValues.description}
            onChange={handleChange}
            sx={formFieldStyle}
            variant="outlined"
          />
          <Box sx={buttonGroupStyle}>
            <Button
              onClick={onClose}
              variant="outlined"
              color="secondary"
              size="large"
              sx={{ width: "48%" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              size="large"
              sx={{ width: "48%" }}
            >
              Save Changes
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default EditProductModal;
